exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "upd-red-cross {\n  display: block;\n}\n\n  upd-red-cross .upd-red-cross-content {\n    text-align: center;\n    padding: 20px;\n  }\n\n  upd-red-cross .upd-red-cross-description {\n    margin: 30px 10px;\n  }\n", ""]);

